$(function(){
	if(!document.querySelector("form.form-sign-in") && !document.getElementById("signinForm") 
			&& !document.getElementById("resendResetPasswordForm") && !document.getElementById("resetpasswordForm") ) return false;
	
	window.snsSignRepolicyCall = function () {
		if($('#eprivacyCookie').length > 0){
			$('#eprivacyCookie').removeClass('active');	
		}
	    reconsentPolicy.init();
	};
	
	jQuery.snsSignInRepolicyCall = function(){
		if($('#eprivacyCookie').length > 0){
			$('#eprivacyCookie').removeClass('active');	
		}
	    reconsentPolicy.init();
	};
	
	// utils
	const utils = {
		flagConvertBoolean : function(_flag){
			if (_flag === "Y") return true;
			return false;
		},
		relocation : function(_url){
			return location.href = _url;
		},
		setFormData : function(_array, _addData){
			let result ={};
			_array.concat(_addData).map(function(pair){
				//LGCOMMON-7300 START
				if(pair.name == "password"){
					pair.value = xssfilter(pair.value + "_NotUseAngleBracketsFilter");
				}else{
					pair.value = xssfilter(pair.value);
				}
				//LGCOMMON-7300 END
				result[pair.name] = pair.value;
			});
			if(!result instanceof Object) return new Error("Please check datatype");
			return result;
		},
		pageGoPost : function(_data) {
            var insdoc = "";
            for (var i = 0; i < _data.vals.length; i++) {
                insdoc += "<input type='hidden' name='" + _data.vals[i][0] + "' value='" + _data.vals[i][1] + "'>";
            }
            var goform = $("<form>", {
                method: "post",
                action: _data.url,
                target: _data.target,
                html: insdoc
            }).appendTo("body");
            goform.submit();
		}
	};
	// ============= LEGACY from common-signin.js START
	const countryCode = $('html').data('countrycode').toUpperCase();
	let cookieA = false;
	
	if(typeof ePrivacyCookies!='undefined' && ePrivacyCookies.get('LGCOM_ADVERTISING')){ // LGEITF-182
		cookieA = true;
	}
	console.log('treasuredata cookie flag : '+cookieA);
	if(cookieA){
		$('head').append('<!-- Treasure Data --><script type="text/javascript">!function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}},s=["blockEvents","unblockEvents","setSignedMode","setAnonymousMode","resetUUID","addRecord","fetchGlobalID","set","trackEvent","trackPageview","trackClicks","ready"],n=0;n<s.length;n++){var c=s[n];e[t].prototype[c]=r(c)}var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/2.2/td.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}("Treasure",this);</script>');
	}
	const sign = {
		el : document.querySelector("form.form-sign-in") || document.getElementById("signinForm"),
		accountErrMsg: document.querySelector('.incorrect-account'),
		cookieName: 'LG5_RememberAccount',
		cookieCheckbox: null,
		accountMail: null,
		hasCaptcha: false,
		//submitData: null,
		//submitInput: $('#signinForm').find('[name="submitData"]'),
		captchaflagUrl: "",
		captchaWrapObj: null,
		empMultiCountryFlag : "N",
		viewPasswordFlag : "N", //LGEBR-1275
		countryCodeCheckbox : document.getElementById("countryCode"),
		// wrongCount: null,
		//LGCOMMON-4858 START
		accountDefaultErrMsg: document.querySelector(".accountDefaultErrMsg"),
		account3rdPartyErrMsg: document.querySelector(".account3rdPartyErrMsg"),
		//LGCOMMON-4858 END

		init: function(){
			// VN language set
			sign.vnLangCheck();
			sign.accountMail = $(sign.el).find('input.email').get(0);
			sign.cookieName += "_" + $('html').data("countrycode") || "";
			sign.cookieCheckbox = $(sign.el).find('input.remember-account').get(0);
			sign.empMultiCountryFlag = $(sign.el).find('[name="empMultiCountryFlag"]').val();
			sign.viewPasswordFlag = $(sign.el).find('[name="viewPasswordFlag"]').val(); //LGEBR-1275
			//sign.addEvent();
			sign.getCookie();

			// captcha fn added
			sign.captchaflagUrl = $(sign.el).data("captchaflagUrl");
			sign.captchaBoxWrap = $(sign.el).find("#captcha-box-wrap");
			sign.captchaContainer = $(sign.el).find(".captcha-area-con");
			sign.askCaptcha();
		},
		// addEvent : function(){
		// 	$(sign.el).on('socialSignin', function(e, _resultData){
		// 		sign.submitData = _resultData;

		// 		const emailAccount = $(sign.el).find('[name="emailAddr"]');
		// 		const submitInput = $(sign.el).find('[name="submitData"]');
		// 		emailAccount.val( sign.submitData.emailAddr );
		// 		submitInput.val( JSON.stringify( sign.submitData ) );

		// 		// escape:policy reconsent
		// 		const isUpdatePolicy = utils.flagConvertBoolean(_resultData.privacyReconsentFlag);
		// 		if ( isUpdatePolicy ) {
		// 			window.EXPIRE_FLAG = !"Y";	// for passed change pw by route on sns login
		// 			return $('#modal_policy_again_emp').modal("show");
		// 		}

		// 		// adobe
		// 		adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});
		// 		sign.bakeCookie();
		// 		setTimeout(function() {
		// 			sign.el.submit();
		// 		}, 100);
		// 	});
		// },
		vnLangCheck: function(){
			// VN korean check
			const lang = $('html').attr('lang');
			if (countryCode == 'VN' && lang == 'KR'){
				$(sign.el).append( '<input type="hidden" name="langType" value="kr">' );
			}
		},
		createCaptcha: function(data){
			sign.captchaBoxWrap.html(data);
		},
		askCaptcha: function( showErrorCbFn ){
			if(!sign.captchaflagUrl) return false;
			if (typeof showErrorCbFn !== 'function'){
				showErrorCbFn = new Function();  // jshint ignore:line
			}
			$.ajax({
				type: "post",
				url: sign.captchaflagUrl,
				async: !1,
				dataType: "json",
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
					//$(sign.el).attr("data-action-url", data.captchaUrl).data("actionUrl", data.captchaUrl);
					if (!!data.captchaHtml){
						sign.createCaptcha(data.captchaHtml);
						sign.captchaContainer.addClass('active');
						sign.hasCaptcha = true;
						controlLabel.init();
						// EMP 2022.02.11 START 이상현 
						return false;
						// EMP 2022.02.11 END 이상현
					}
					// show error
					showErrorCbFn();
				},
				error: function(request, status, error) {
					console.log("status: "+status);
					console.log("error: "+error);
				}
			});
		},
		getCookie: function(){
			let ac = getCookie(sign.cookieName);
			let cc = "";
			var cookieArr = []; 
			if(ac !== undefined && ac !== '') {
				if(sign.empMultiCountryFlag == 'Y'){
					
					cookieArr = ac.split(",");
					ac = cookieArr[0];
					cc = cookieArr[1];
					
					let optionValue = sign.countryCodeCheckbox;
					for(var ccIndex=0; optionValue.length > ccIndex; ccIndex++){
						if(optionValue[ccIndex].value == cc){
							optionValue[ccIndex].selected = true;
							$(optionValue).trigger('chosen:updated');
					        $(optionValue).trigger('chosen:activate');
						}
					}
				}
				sign.cookieCheckbox.checked = true;
				sign.accountMail.value = ac;
			} else {
				if(sign.empMultiCountryFlag == 'Y'){
					sign.defaultMultiCountry();
				}
			}
		},
		bakeCookie: function(){
			// 20200325 START 김우람 || 쿠키제어 삭제 
			if(sign.cookieCheckbox.checked) {
				// bake account cookie
				const ac = xssfilter($(sign.el).find('input.email').get(0).value);
				if(sign.empMultiCountryFlag === 'Y'){
					const cc = xssfilter(sign.countryCodeCheckbox.options[sign.countryCodeCheckbox.selectedIndex].value);
					setCookie(sign.cookieName, ac+","+cc);
				} else {
					setCookie(sign.cookieName, ac);
				}
				//$.cookie(sign.cookieName, encodeURIComponent(ac), {expires:30});
			}else {
				removeCookie(sign.cookieName);
			}
			/* LGEBR-1296 S*/
			if(countryCode == 'BR'){
			    if(location.hash=="#my-order"){
			    	setCookie("LG5_my_order","Y",true,"","",true);
			    }
			}
		    /* LGEBR-1296 E*/
		},
		defaultMultiCountry : function(){
			
				var _mUrl = $(sign.countryCodeCheckbox).data("multicountryUrl");
				
				$.ajax({
					type: "post",
					url: _mUrl,
					dataType: "json",
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						
						let optionValue = sign.countryCodeCheckbox;
						let defaultCountry = data.defaultCountry;
						let defaultCountryCode = defaultCountry.countryCode; 
						
						if(data.status == 'success'){
							for(var cIndex=0; optionValue.length > cIndex; cIndex++){
									if(optionValue[cIndex].value == defaultCountryCode){
										optionValue[cIndex].selected = true;
									}else{
										optionValue[0].selected = true;
									}
							}
						} else {
							optionValue[0].selected = true;
						}
						$(optionValue).addClass('inputted');
						$(optionValue).trigger('chosen:updated');
				        $(optionValue).trigger('chosen:activate');
					},
					error: function(request, status, error) {
						console.log("status: "+status);
						console.log("error: "+error);
					}
				});
			
		},
		// EMP 2022.02.11 START 이상현 - sign in 성공 시 호출
		login : function(data){
			// adobe
			adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});
			// LGEGMC-3469 Start
			if(salesForceUseFlag || salesForceUseFlagV2){ // LGEGMC-5141
				console.log('ecrmLogined insert');
				SalesforceInteractions.sendEvent({
					interaction: {
						name: 'ecrmLogined',
						eventType: 'ecrmLogined',
						ecrmUserId: autoNvl(data.lgeId),
						ecrmLocaleCode: autoNvl(data.countryCode),
						ecrmHostType: deviceTypeComm() // LGEITF-900
					}
				})
			};
			// LGEGMC-3469 End
			// keep emmail info
			sign.bakeCookie();
			// LGEUK-124 Start
			setTimeout(function() {
				//LGEGMC-4064 start
				if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMTIF-123
					treasuredataInit(data, 'signInNomalSubmit');
				}else{
					//LGCOMITF-123-2 start
					if ( cookieA ) {
						nonTreasureDataInsertTable(data);
					}
					//LGCOMITF-123-2 end
					sign.el.submit();
				}
				//LGEGMC-4064 end
				console.log('-----------------------------------------------signin submit');
			}, 100);
			// LGEUK-124 End
		}
		// EMP 2022.02.11 END 이상현
	}
	// LGEUK-124 Start 
	// Treasure Data Tracking
	let td_client_id_cookie = '';
	let td_global_id = '';
	let td_ssc_id = '';
	function getCookieTd(name) {
		if ($.cookie(name)) {
			return decodeURIComponent($.cookie(name));
		} else {
			$.cookie(name);
		}
	}
	function treasuredataInit(resultData, type) {
		const tdLoginStatus = new Treasure({  // LGEITF-182 
			host: 'eu01.in.treasuredata.com',
			writeKey: resultData.apikey,
			database: resultData.database,
			sscDomain: 'lg.com',
			sscServer: 'ssc.lg.com',
			useServerSideCookie: true
		});

		tdLoginStatus.setSignedMode();  // LGEITF-182

		// Enable cross-domain tracking
		tdLoginStatus.set('$global', 'td_global_id', 'td_global_id');  // LGEITF-182
		// Receive td_global_id
		const successCallback = function(td_global_id_data) {
			console.log('successCallback');
			td_global_id = td_global_id_data;
			td_client_id_cookie = getCookieTd('_td');
			treasuredataAjax(resultData);
		
			// LGEITF-182 Start
			if(type != "FAIL"){
				sign.el.submit();
			}
			// LGEITF-182 End
		};
		const errorCallback = function(err) {
			console.log('errorCallback');
			td_client_id_cookie = getCookieTd('_td');
			treasuredataAjax(resultData);
			
			// LGEITF-182 Start
			if(type != "FAIL"){
				sign.el.submit();
			}
			// LGEITF-182 End
		};
		// Track pageview information to 'TABLE_NAME' table
		const successCallback_ssc = function (serverSideId) {
			console.log('successCallback_ssc');
			td_ssc_id = serverSideId;
			tdLoginStatus.fetchGlobalID(successCallback, errorCallback);  // LGEITF-182
		};
		const errorCallback_ssc = function (error) {
			console.log('errorCallback_ssc :: '+error);
		};
		tdLoginStatus.fetchServerCookie(successCallback_ssc, errorCallback_ssc);  // LGEITF-182
	}
	function treasuredataAjax(resultData){
		let treasuredataUrl = resultData.host; // LGEITF-421
			treasuredataUrl += resultData.database+ '/'
			treasuredataUrl += resultData.table+ '?'
			treasuredataUrl += 'td_write_key='+resultData.apikey;
			treasuredataUrl += '&td_client_id='+td_client_id_cookie;
			treasuredataUrl += '&td_global_id='+td_global_id;
			treasuredataUrl += '&td_ssc_id='+td_ssc_id;
		
			// LGEITF-182 Start
			if(resultData.timeSuccess)
				treasuredataUrl += '&time_success='+resultData.timeSuccess;
			if(resultData.typeSuccess)
				treasuredataUrl += '&type_success='+resultData.typeSuccess;
			if(resultData.typeLogin)
				treasuredataUrl += '&type_login='+resultData.typeLogin;
			if(resultData.typeSocial)
				treasuredataUrl += '&type_social='+resultData.typeSocial;
			if(resultData.lgeId)
				treasuredataUrl += '&lge_id='+resultData.lgeId;
			if(resultData.tdEmail)
				treasuredataUrl += '&email='+resultData.tdEmail;
			if(resultData.tdPhone)
				treasuredataUrl += '&phone='+resultData.tdPhone;
			if(resultData.nameFirst)
				treasuredataUrl += '&name_first='+resultData.nameFirst;
			if(resultData.nameLast)
				treasuredataUrl += '&name_last='+resultData.nameLast;
			if(resultData.sodialIdTwitter)
				treasuredataUrl += '&social_id_twitter='+resultData.sodialIdTwitter;
			if(resultData.screenNameTwitter)
				treasuredataUrl += '&screen_name_twitter='+resultData.screenNameTwitter;
			if(resultData.socialIdFb)
				treasuredataUrl += '&social_id_fb='+resultData.socialIdFb;
			if(resultData.nameFullFb)
				treasuredataUrl += '&name_full_fb='+resultData.nameFullFb;
			if(resultData.typeLoginResult)
				treasuredataUrl += '&type_login_result='+resultData.typeLoginResult;
			if(resultData.failMessage)
				treasuredataUrl += '&type_fail_reason='+resultData.failMessage;
			if(resultData.localeCode)
				treasuredataUrl += '&locale_code='+resultData.localeCode;
			if(resultData.corporationCode)
				treasuredataUrl += '&corporation_code='+resultData.corporationCode;
			if(resultData.cdpNameCode)
				treasuredataUrl += '&cdp_name_code='+resultData.cdpNameCode;
			if(resultData.cdpName)
				treasuredataUrl += '&cdp_name='+resultData.cdpName;
			if(resultData.tdTypeFail)
				treasuredataUrl += '&type_fail='+resultData.tdTypeFail;
			if(resultData.noPhoneNameReason)
				treasuredataUrl += '&no_phone_name_reason='+resultData.noPhoneNameReason;
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataUrl += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + resultData.socialIdEtc;
			// LGEITF-182 End

		if(cookieA && treasureDataFlag == 'Y'){
			$.ajax({
				url : treasuredataUrl,
				type : 'POST',
				dataType : 'jsonp',
				jsonpCallback: "callback",
				async: false,
				crossDomain: true,
				beforeSend: function (xhr) {
					xhr.setRequestHeader("Content-type","application/json");
					xhr.setRequestHeader("X-TD-Write-Key",resultData.apikey);
				},
				success : function(data){
					// console.log(data);
					console.log('treasuredata post success'); // LGEIN-239
				}
			});
		}
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		if(resultData.apikey)
			treasuredataInsertParam += 'td_write_key='+encodeURIComponent(resultData.apikey);
		if(td_client_id_cookie)
			treasuredataInsertParam += '&td_client_id='+encodeURIComponent(td_client_id_cookie);
		if(td_global_id)
			treasuredataInsertParam += '&td_global_id='+encodeURIComponent(td_global_id);
		if(td_ssc_id)
			treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent(td_ssc_id);
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	
	//LGCOMITF-123-2 start
	function nonTreasureDataInsertTable(resultData){
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		
		//Treasure Data 미사용국가들로 인해 해당데이터는 공백으로 넘겨짐. EDL 에서도 로그인 이력이 필요할뿐 Td 관련된 데이터는 필요 없음.
		treasuredataInsertParam += 'td_write_key='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_client_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_global_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent('N/A');
			
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	//LGCOMITF-123-2 end
	
	// function nvl(str, defaultStr){
	// 	var check = str+"";
	// 	var result = "";
	// 	check = check.trim()
	// 	if(check=="" || check==null || check == "null" || check=="undefined"){
	// 		result = defaultStr;
	// 	}else{
	// 		result = check;
	// 	}
	// 	return result ;
	// }
	// LGEUK-124 End

	// PJTGPEMP-1 Start
	const user_exist = getParameterByName("user_exist");
	const user_expire = getParameterByName("user_expire");
	if(user_exist == 'true'){
		$('.lgaccount-user-exist').show().siblings().hide();
		$('#modal_user_exist').modal('show');
	} else if(user_expire == 'true'){
		$('.lgaccount-user-expire').show().siblings().hide();
		$('#modal_user_exist').modal('show');
	}
	function getParameterByName(name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		const results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}
	// PJTGPEMP-1 End

	const fgpw = {
		el: document.getElementById('forgotForm'), // form
		modal: document.getElementById('find_my_password'), // modal popup
		accountMail: null,
		init: function(){
			fgpw.accountMail = $(fgpw.el).find('input.email').get(0);
			fgpw.addEvent();
		},
		beforeSubmit: function(e){
			e.preventDefault();
			// ajax validation
			if($(fgpw.el).checkValidation()){
				if(captcha && captcha.validation()){
					fgpw.el.submit();
				}else if(!captcha){
					fgpw.el.submit();
				}
				
				//Not need ajax.
				// var url = fgpw.el.action;
				// var param = xssfilter($(fgpw.el).serialize());
				// var methodType = $(sign.el).data('ajaxMethod');
				// ajax.call(url, param, 'json', function(data){
				// 	if(data.result == true){
				// 		$(fgpw.accountMail).parents('.field-block').removeClass('error');
				// 		$(fgpw.modal).find('.msg-box .email').text(fgpw.accountMail.value);
				// 		$(fgpw.modal).modal('show');
				// 	}else {
				// 		$(fgpw.accountMail).parents('.field-block').addClass('error')
				// 			.find('.registered').show().siblings().hide();
				// 	}
				// },methodType);
			}
		},
		addEvent: function(){
			$(fgpw.el).on({
				submit: fgpw.beforeSubmit
			});
			// $(fgpw.el.forgotFormTrigger).on({
			// 	click: fgpw.beforeSubmit
			// });
		}
	};
	
	// ============= LEGACY from common-signin.js END

	// interface 
	const EXPIRE_PASSWORD = "expire password";
	const RESET_PASSWORD = "reset password";    		// over count wrong pw
	const RESET_PASSWORD_EMP = "reset password:emp";    // over count wrong pw
	const GO_TO_INTERGRATION = "go to intergration";
	const POLICY_RECONSENT = "policy reconsent";
	// variable
	const emailkeyname = "emailAddr";
	// object:sign in form 
	const signinEmp = {
		form : document.querySelector("form.form-sign-in") || document.getElementById('signinForm'),
		modal : {
			policy : "#modal_policy_again_emp", 
			changepw : "#modal_change_my_password", 
		},
		init : function(){
			const self = signinEmp;
			self.eventRegistry();
			// for legacy - "sign" - setting 
			$(sign.accountErrMsg).removeClass("show");
		},
		eventRegistry : function(){
			const self = signinEmp;
			$(self.form).on({
				submit : self.api.submit
			});
		},
		// api, utils
		api : {
			submit : function(e){
				e.preventDefault();
				
				/* LGEGMC-4766 start */
            	if( $("#g-recaptcha").length > 0 && $('#g-sitekey').length > 0 && $("#useNewCaptchaView").length > 0 && $("#useNewCaptchaView").val() == "N"){
    				var reCaptcha_Key = $('#g-sitekey').val();
    	        	grecaptcha.enterprise.ready(function() {
    	        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
    	        			$("#g-recaptcha").val(btoa(token));
    	        			sendSignIn();
    	        		});
    	        	});
    			}else{
    				sendSignIn();
    			}
    			/* LGEGMC-4766 end */
            	
            	function sendSignIn(){
            		// dom
					const self = signinEmp;
					const isPassedValidate = $(self.form).checkValidation();
					if(!isPassedValidate) return false;
					const target = e.currentTarget instanceof HTMLFormElement && e.currentTarget || self.form;
					// for xhr header
					const url = target.dataset.actionUrl;
					const formData = utils.setFormData( 
						$(target).serializeArray(), 
						[
							{name : "treasureType", value : "login"},
							{name : "tdloginType", value : "normal"}
						] 
					);
					// ajax
					self.api.request(url, formData);
            	}
			},
			request : function(_url, _data){
				const self = signinEmp;
				$.ajax({
					type : "post",
					url : _url,
					data : _data,
					dataType : "json",
					async : false,
					contentType : 'application/x-www-form-urlencoded; charset=UTF-8',
					xhrFields : {
						withCredentials : true
					},
					success : self.api.afterRequest,
					error : self.api.error,
					beforeSend: function () {
						return $('body').trigger('ajaxLoadBefore');
					},
					complete: function(){
						$('body').trigger('ajaxLoadEnd');
					}
				});
			},
			afterRequest : function(response){
				const submitInput = $(signinEmp.form).find('[name="submitData"]');
				submitInput.val( JSON.stringify(response) );
				
				const self = signinEmp;
				// ===============
				// [ status:fail ]
				// ===============
				// escape:fail
				const isReceiveSuccess = response.status === "success" ? true : false;
				if(!isReceiveSuccess) return self.api.fail(response);
				console.log("status:success");
				// ===============
				// [ status:success ]
				// ===============
				const flag = {
					// new for emp
					"reset password":  response.passwordResetFlag,
					"reset password:emp":  response.passwordResetEmpFlag,
					"go to intergration" : response.combineProgressFlag,
					"policy reconsent" : response.privacyReconsentFlag,
					"expire password":  response.passwordExpireFlag,
				};
				const url = {
					"reset password" : response.passwordChangeUrl,
					"reset password:emp": response.passwordChangeEmpUrl,
					"go to intergration" : response.combineProgressUrl,
					"policy reconsent" : response.privacyReconsentUrl,
				};
				// == pw is wrong ==
				// escape:over count
				const isOverCountWrongPassword = (function(array){
					const flag_internal = array[0];
					const flag_emp = array[1];
					if(!flag_internal && !flag_emp) return false;
					if(flag_emp) return utils.relocation(url[RESET_PASSWORD_EMP]);
					if(flag_internal) return utils.relocation(url[RESET_PASSWORD]);
					return true;
				})([
					utils.flagConvertBoolean(flag[RESET_PASSWORD]),
					utils.flagConvertBoolean(flag[RESET_PASSWORD_EMP])
				]);
				if(isOverCountWrongPassword) return false;
				// escape:under count
				if(response.error.message){
					const msg = response.error.message;
					const $msgbox = $(self.form).find('input[name="password"]').parent().find(".ajax-msg");
					self.api.indicateMsg($msgbox, msg);
				}
				// == pw matched ==
				// escape:not yet combine
				const isPassedCombine = utils.flagConvertBoolean(flag[GO_TO_INTERGRATION]); 
				if(isPassedCombine) {
					return utils.pageGoPost({
	                    url : url[GO_TO_INTERGRATION],
	                    target : "_self",
	                    vals : [
	                        ["emailAddr", $(self.form).find('input[name="emailAddr"]').val()],
	                        ["accessKey", response.accessKey],
	                        ["countryCode",COUNTRY_CODE.toUpperCase()]
	                    ]
	                    
	                });
				}
				// escape:agreement updated policy 
				const isUpdatePolicy = utils.flagConvertBoolean(flag[POLICY_RECONSENT]);
				const isExpirePassword = utils.flagConvertBoolean(flag[EXPIRE_PASSWORD]);
				var selectEmpCountry = sign.empMultiCountryFlag == 'Y' ? sign.countryCodeCheckbox.options[sign.countryCodeCheckbox.selectedIndex].value : response.data.user.empCountryCode;
				
				if(isUpdatePolicy) {
					// memo flag 
					window.EXPIRE_FLAG = isExpirePassword;
					// isExpirePassword,isUpdatePolicy all True
					if(isExpirePassword){
						$.ajax({
							url : url[RESET_PASSWORD_EMP],
							data : {
								empSid : response.data.user.empLoginSessionID,
								empCountryCode : selectEmpCountry,
								emailAddr : response.data.user.emailAddr
							},
							async : false,
							contentType : 'application/x-www-form-urlencoded; charset=UTF-8',
							xhrFields : {
								withCredentials : true
							},
							success : function(data){
								$('#modal_change_my_password').html(data);
							},
							error : self.api.error,
							complete: function(){
								if($('#eprivacyCookie').length > 0){
									$('#eprivacyCookie').removeClass('active');	
								}
								changePassword.init();
							}
						});
					}
					// floating modal
					const floatingTargetModal = reconsentPolicy.modal || self.modal.policy;
					$.ajax({
						url : url[POLICY_RECONSENT],
						data : {
							empSid : response.data.user.empLoginSessionID,
							countryCode : selectEmpCountry,
							reConsentTerms : response.reConsentTerms,
							empCustomerNo : response.data.user.mbrNo,
							customerNo : response.data.user.userId,
							emailAddr : response.data.user.emailAddr
						},
						async : false,
						contentType : 'application/x-www-form-urlencoded; charset=UTF-8',
						xhrFields : {
							withCredentials : true
						},
						success : function(data){
							$('#modal_policy_again_emp').html(data);
						},
						error : self.api.error,
						complete: function(){
							if($('#eprivacyCookie').length > 0){
								$('#eprivacyCookie').removeClass('active');	
							}
							reconsentPolicy.init();
						}
					});
					
					$(floatingTargetModal).modal("show");
					return $('body').trigger('ajaxLoadEnd');
				};
				// escape:expire password
				if(isExpirePassword) {
					window.EXPIRE_FLAG = isExpirePassword;
					$.ajax({
						url : url[RESET_PASSWORD_EMP],
						data : {
							empSid : response.data.user.empLoginSessionID,
							empCountryCode : selectEmpCountry,
							emailAddr : response.data.user.emailAddr
						},
						async : false,
						contentType : 'application/x-www-form-urlencoded; charset=UTF-8',
						xhrFields : {
							withCredentials : true
						},
						success : function(data){
							$('#modal_change_my_password').html(data);
						},
						error : self.api.error,
						complete: function(){
							if($('#eprivacyCookie').length > 0){
								$('#eprivacyCookie').removeClass('active');	
							}
							changePassword.init();
						}
					});
					
					$(self.modal.changepw).modal("show");
					return $('body').trigger('ajaxLoadEnd');
				};
				// final done
				sign.login(response);
				$('body').trigger('ajaxLoadEnd');
			},
			fail : function(data){
				// validation fail
				
				//PJTJOINMEMEBER-1 Start
				if (typeof data.error.signUpMailVerification != 'undefined' && data.error.signUpMailVerification == 'Y'){
					const goToForm = document.getElementById("goComplete");
					const inputTag1 = $("<input>").attr("type", "hidden").attr("name", "emailAddr").val($('input[name=emailAddr]').val());
					const inputTag2 = $("<input>").attr("type", "hidden").attr("name", "submitData").val('{"goToInboxUrl":"'+data.error.goToInboxUrl+'"}');
					$('#goComplete').append($(inputTag1)).append($(inputTag2));
					goToForm.submit();
					return;
				}
				
				if (typeof data.error.signUpMailNotVerify != 'undefined' && data.error.signUpMailNotVerify == 'Y'){
					var selfCheck = signinEmp;
					$(selfCheck.form).find('input[name="emailAddr"]').parent().addClass('error').find('.error-msg').show().find('.ajax-msg').text(data.error.message).show().siblings().hide();
					$(selfCheck.form).find('input[name="emailAddr"]').focus();
					$(sign.accountErrMsg).removeClass("show");
				}
				//PJTJOINMEMEBER-1 End
				
				// LGECI-541 start
				if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
					if( !!$('#g-recaptcha').val() && $("#useNewCaptchaView").val() == "Y"){
						reload_recaptcha_wrapper();
					}
				}
				
				var formSerializeArray = $('#signinForm').serializeArray();
				var object = {};
				for (var i = 0; i < formSerializeArray.length; i++){
					object[formSerializeArray[i].name] = formSerializeArray[i].value;
				}
				object.emailAddr = xssfilter( $('#txtBoxEmail').val() );
				object.password = xssfilter( $('#txtBoxPassword').val() + "_NotUseAngleBracketsFilter" ); //LGCOMMON-7300
				// LGEITF-182 Start
				object["treasureType"] = "login";
				object["tdloginType"] = "normal";
				
				// LGECI-541 end
				// LGEITF-182, LGEGMC-4064 Start
				if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
					let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
					if(window.location.href.indexOf('/oauth/') >=0) {
						const actionURL = ($(sign.el).data('action-url').length>0) ? $(sign.el).data('action-url') : null;
						if(actionURL.indexOf('wdev50.lg.com')>=0) {
							tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
							tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('www.lg.com')>=0){
							tdFailUrl="https://www.lg.com"+tdFailUrl;
						}else{
							tdFailUrl="https://"+window.location.host+tdFailUrl;
						}
					}
					
					$.ajax({
						type: 'post',
						url: tdFailUrl,
						dataType: 'json',
						data: object,
						xhrFields: {
							withCredentials: true
						},
						async: false,
						success: function(failData) {
							if(data.error.tdMessage){
								failData["failMessage"]=data.error.tdMessage;
							}else{
								failData["failMessage"]=data.error.message;
							}
							if(data.error.tdTypeFail){
								failData["tdTypeFail"]=data.error.tdTypeFail;
							}
							treasuredataInit(failData,'FAIL');
						},
						error: function(request,status,error) {
							console.log("status: "+status);
							console.log("error: "+error);
						}
					});
				//LGCOMITF-123-2 start
				} else if ( cookieA ) {
					let tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
					if(window.location.href.indexOf('/oauth/') >=0) {
						const actionURL = ($(sign.el).data('action-url').length>0) ? $(sign.el).data('action-url') : null;
						if(actionURL.indexOf('wdev50.lg.com')>=0) {
							tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
							tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
						} else if(actionURL.indexOf('www.lg.com')>=0){
							tdFailUrl="https://www.lg.com"+tdFailUrl;
						}else{
							tdFailUrl="https://"+window.location.host+tdFailUrl;
						}
					}
					
					$.ajax({
						type: 'post',
						url: tdFailUrl,
						dataType: 'json',
						data: object,
						xhrFields: {
							withCredentials: true
						},
						async: false,
						success: function(failData) {
							if(data.error.tdMessage){
								failData["failMessage"]=data.error.tdMessage;
							}else{
								failData["failMessage"]=data.error.message;
							}
							if(data.error.tdTypeFail){
								failData["tdTypeFail"]=data.error.tdTypeFail;
							}
							nonTreasureDataInsertTable(failData);
						},
						error: function(request,status,error) {
							console.log("status: "+status);
							console.log("error: "+error);
						}
					});
				}
				//LGCOMITF-123-2 end
				adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});

				sign.bakeCookie();

				sign.askCaptcha(function(){
					for (var key in data.error) {
						var $field = $(sign.el).find('input[name="' + key + '"]');
						
						if ($field.length) {
							sign.showError($field, '.ajax-msg', data.error[key]);
						}
					}
				});
				
				if (typeof data.error.signUpMailNotVerify != 'undefined'){
				}else {
					$(sign.accountErrMsg).addClass("show");
				}
				// LGEITF-182, LGEGMC-4064 End
				//LGCOMMON-4858 START
				if(data.error.empSignIn3rdPartyErrorFlag == 'Y'){
					$(sign.accountDefaultErrMsg).addClass("d-none");
					$(sign.account3rdPartyErrMsg).removeClass("d-none");
				}else{
					$(sign.accountDefaultErrMsg).removeClass("d-none");
					$(sign.account3rdPartyErrMsg).addClass("d-none");
				}
				//LGCOMMON-4858 END
			},
			error : function(response){
				const self = signinEmp;
				const $msgbox = $(self.form).find(".system-error");
				self.api.indicateMsg($msgbox, "static");
				$('body').trigger('ajaxLoadEnd');
			},
			indicateMsg : function(_$msgbox, _msg){
				// static msg
				const isStaticMsg = _msg === "static" ? true : false; 
				if(isStaticMsg) return _$msgbox.addClass("show");
				// dynamic msg
				const isMultiLine = 0 < _msg.indexOf('<br')
				if(isMultiLine) return _$msgbox.html(_msg);
				_$msgbox.text(_msg);
			}
		}
	}
	// object:reconsent policy
	const reconsentPolicy = {
		form : document.querySelector('form.form-policy-again-emp'),
		modal : document.querySelector('#modal_policy_again_emp'),
		init : function(){
			reconsentPolicy.form = document.querySelector('form.form-policy-again-emp');
			reconsentPolicy.modal = document.querySelector('#modal_policy_again_emp');
			const self = reconsentPolicy;
			self.policyEvent();
		},
		policyEvent : function(){
			const self = reconsentPolicy;
			$(self.modal).on({
				"shown.bs.modal" : function(){
					// 
					// $(this).find('.field-chk :checkbox').prop('checked', false).each(function(){
					// 	var checkbox = $(this);
					// 	if ( sign.submitData.privacyData[ checkbox.attr('name') ] === "Y" ){
					// 		checkbox.prop('checked', true);
					// 	}
					// });
					// // 20200818 LGESG-105
					// if ( COUNTRY_CODE === 'sg' ) {
					// 	$('#privacyAgain-chk1, #privacyAgain-chk2').prop('checked',true);
					// }
				},
				"hidden.bs.modal" : function(){
					// location.reload();
				}
			});
			$(self.form).on({
				submit : self.api.submit
			});
			// check it all at once
			const btn_chk_all = $(self.modal).find('#privacychk_all');
			const privacychk_pack = $(self.modal).find("input[type='checkbox'].privacychk_pack");
			//LGEGMC-3917 START 
			const $privacychk4 = $('input[id=privacychk_4]');
			const $privacychk5 = $('input[id=privacychk_5]');
			const $privacychk6 = $('input[id=privacychk_6]');
			//LGEGMC-3917 END
			
			const $privacychk8 = $('input[id=privacychk_8]');	//LGCOMMON-8347
			
			// LGEPL-656 start
			const $markChk = $('input[id=privacychk_4]');
			const $markChk_1 = $('input[id=contactEmailOrder]');
			const $markChk_2 = $('input[id=contactSmsOrder]');
			const $markChk_3 = $('input[id=contactNumberOrder]');
			
			btn_chk_all.on({
				click : function(){
					privacychk_pack.prop('checked', this.checked);
					//LGEGMC-3917 LGEIS-978, LGEPL-656 START
					if(COUNTRY_CODE != 'ca_en' && COUNTRY_CODE != 'ca_fr' && COUNTRY_CODE != 'it'){
						if($($privacychk4).prop('checked') == true){
							if( COUNTRY_CODE != 'pl'){
								$($privacychk4).parents('p').next('p').addClass('show');
							}
							
							if( $markChk_1.length > 0)$markChk_1.prop("checked", true).attr("checked");
							if( $markChk_2.length > 0)$markChk_2.prop("checked", true).attr("checked");
							if( $markChk_3.length > 0)$markChk_3.prop("checked", true).attr("checked");
						}else{
							if( COUNTRY_CODE != 'pl'){
								$($privacychk4).parents('p').next('p').removeClass('show');
							}
							
							if( $markChk_1.length > 0)$markChk_1.prop("checked", false).removeAttr("checked");
							if( $markChk_2.length > 0)$markChk_2.prop("checked", false).removeAttr("checked");
							if( $markChk_3.length > 0)$markChk_3.prop("checked", false).removeAttr("checked");
						}	
					}
					//LGEGMC-3917 LGEIS-978, LGEPL-656 END
					
					//LGCOMMON-8347 START
					if($($privacychk8).prop('checked') == true){
						$($privacychk8).parents('p').find('.personal').removeClass("d-none");
					}else{
						$($privacychk8).parents('p').find('.personal').addClass("d-none");
					}
					//LGCOMMON-8347 END
				}
			});
			// LGEPL-656 end
			privacychk_pack.on({
				change : function(){
					const max = privacychk_pack.length; 
					const now = privacychk_pack.filter(":checked").length;
					btn_chk_all.prop('checked', max == now ? true : false);
				}
			});
			//LGEITF-672 Start			
			
			//LGEGMC-3917 LGEIS-978, LGEPL-656 START
			if(COUNTRY_CODE != 'ca_en' && COUNTRY_CODE != 'ca_fr' && COUNTRY_CODE != 'it' && COUNTRY_CODE != 'pl'){
				$privacychk4.on('change', function () {
					if($($privacychk4).prop('checked') == true){
						$($privacychk4).parents('p').next('p').addClass('show');
					}else{
						$($privacychk4).parents('p').next('p').removeClass('show');
					}	
				})
			}
			//LGEGMC-3917 LGEIS-978, LGEPL-656 END
			
			//LGCOMMON-8347 START
			$privacychk8.on('change', function () {
				if($($privacychk8).prop('checked') == true){
					$($privacychk8).parents('p').find('.personal').removeClass("d-none");
				}else{
					$($privacychk8).parents('p').find('.personal').addClass("d-none");
				}	
			});
			//LGCOMMON-8347 END
			
			if (COUNTRY_CODE == 'it') {
				$('.chk-info').addClass('show'); // LGEIS-978
				$privacychk4.click(function() {		
				if(!$privacychk4.prop("checked") == true){
					$privacychk5.prop("checked", false).removeAttr("checked");
					$privacychk6.prop("checked", false).removeAttr("checked");
						}
				})
				
				$privacychk5.click(function() {		
				if($privacychk5.prop("checked") == true){
					$privacychk4.prop("checked", true).attr("checked");
						}
				})
				
				$privacychk6.click(function() {		
				if($privacychk6.prop("checked") == true){
					$privacychk4.prop("checked", true).attr("checked");
						}
				})
			}
			//LGEITF-672 END
			
			// LGEPL-656 start	
			if( $markChk.length > 0){
				$markChk.click(function() {		
					if(!$markChk.prop("checked") == true){
						if( $markChk_1.length > 0)$markChk_1.prop("checked", false).removeAttr("checked");
						if( $markChk_2.length > 0)$markChk_2.prop("checked", false).removeAttr("checked");
						if( $markChk_3.length > 0)$markChk_3.prop("checked", false).removeAttr("checked");
					}else{
						if( $markChk_1.length > 0)$markChk_1.prop("checked", true).attr("checked");
						if( $markChk_2.length > 0)$markChk_2.prop("checked", true).attr("checked");
						if( $markChk_3.length > 0)$markChk_3.prop("checked", true).attr("checked");
					}
				});
			}
			
			if( $markChk.length > 0 && $markChk_1.length > 0){
				$markChk_1.click(function() {		
					if($markChk_1.prop("checked") == true){
						$markChk.prop("checked", true).attr("checked");
						//$markChk.parents('label').next().addClass('show');
					}
				});
			}
			 
			if( $markChk.length > 0 && $markChk_2.length > 0){
				$markChk_2.click(function() {		
					if($markChk_2.prop("checked") == true){
						$markChk.prop("checked", true).attr("checked");
						//$markChk.parents('label').next().addClass('show');
					}
				});
			}
			
			if( $markChk.length > 0 && $markChk_3.length > 0){
				$markChk_3.click(function() {		
					if($markChk_3.prop("checked") == true){
						$markChk.prop("checked", true).attr("checked");
						//$markChk.parents('label').next().addClass('show');
					}
				});
			}
			// LGEPL-656 end
		},
		api : {
			submit : function(e){
				e.preventDefault();
				const self = reconsentPolicy;
				const isPassedValidate = $(self.form).checkValidation();
				if(!isPassedValidate) return false;

				// ============
				// is valid
				// ============
				// == ajax ==
				// set form data
				/*const thisFormData = $(self.form).serializeArray().map(function(pair){
					return {
						name : pair.name,
						value : pair.value
					};
				});
				const addData =	[{
					name : emailkeyname, 
					value : signinEmp.form.querySelector('input[name=\"' + emailkeyname + '\"]').value
				}];*/
				const formData = $(e.currentTarget).serialize();
				// call
				self.api.request(self.form.dataset.url, formData);
			},
			request : function(_url, _data){
				const self = reconsentPolicy;
				
				/*var chked_val = "";
				var unChked_val = "";
				$("input[name='policyTypeList']").each(function(pi,po){
					chked_val += ","+po.value;
				});
				if($("input[name='policyTypeList empOptionalAgreementFlag']").length > 0){
					if($("input[name='policyTypeList empOptionalAgreementFlag']").prop("checked")){
	                    chked_val += ","+$("input[name='policyTypeList empOptionalAgreementFlag']").val();
	                }else{
						unChked_val += ","+$("input[name='policyTypeList empOptionalAgreementFlag']").val();
					}
				}
				if($("input[name='policyTypeList empProfileOptionalFlag']").length > 0){
	                if($("input[name='policyTypeList empProfileOptionalFlag']").prop("checked")){
	                	chked_val += ","+$("input[name='policyTypeList empProfileOptionalFlag']").val();
	                }else{
						unChked_val += ","+$("input[name='policyTypeList empProfileOptionalFlag']").val();
					}
				}
				if(chked_val!="") chked_val = chked_val.substring(1);
				if(unChked_val!="") _data+='&policyUnChkedNameList='+unChked_val.substring(1);
				_data+='&policyNameList='+chked_val;*/
				
				//test
				var chked_val = "";
				var unChked_val = "";
				
				$("input[name='policyTypeList']:checked").each(function(pi,po) {
					chked_val += ","+po.value;
				});
				
				$("input[name='policyTypeList']:not(':checked')").each(function(pi,po) {
					unChked_val +=  "," + po.value;
				});
				if(chked_val!="") chked_val = chked_val.substring(1);
				if(unChked_val!="") _data+='&policyUnChkedNameList='+unChked_val.substring(1);
				_data+='&policyNameList='+chked_val;
				//test
				
				
				_data+="&emailAddr="+signinEmp.form.querySelector('input[name=\"' + emailkeyname + '\"]').value;
				
				$.ajax({
					type : "post",
					url : _url,
					data : _data,
					dataType : "json",
					async : false,
					contentType : 'application/x-www-form-urlencoded; charset=UTF-8',
					xhrFields : {
						withCredentials : true
					},
					success : self.api.afterRequest,
					error : self.api.error
				});
			},
			afterRequest : function(response){
				const self = reconsentPolicy;
				const isPasswordExpire = window.EXPIRE_FLAG;
				// login
				if(response.code === "200"){
					if(isPasswordExpire){
						$(self.modal).modal("hide");
						$(signinEmp.modal.changepw).modal("show");
						return false;
					}
					var reconsentSubmitData = JSON.parse($('input[name=submitData]').val());
					sign.login(reconsentSubmitData);
				}else{
					//fail
					$(self.modal).modal("hide");
				}
			},
			error : function(response){
				console.log(response.status);
			}
		}
	};
	// object:change password
	const changePassword = {
		el: {
			"change:later" : document.querySelector('form.form-extend-password-expire'),
			"change:now" : document.querySelector('form.form-change-password')
		},
		modal : {
			"self" : "#modal_change_my_password",
			"error" : "#modal_change_my_password_fail",
			"success" : "#modal_change_my_password_success"
		},
		action : {
			CHANGE_LATER : "change:later",
			CHANGE_NOW : "change:now"
		},
		init: function(){
			var self = changePassword;
			self.el[self.action.CHANGE_LATER] = document.querySelector('form.form-extend-password-expire');
			self.el[self.action.CHANGE_NOW] = document.querySelector('form.form-change-password');
			self.changepwEvent();
		},
		changepwEvent: function(){
			//수정 필요 서브밋 url찾을수있도록 
			var self = changePassword;
			self.el[self.action.CHANGE_LATER] = document.querySelector('form.form-extend-password-expire');
			Object.keys(self.action).map(function(key){
				var k = self.action[key];
				$(self.el[k]).on({
					submit : self.interactionAPI[k]
				});
			});
			var ExtendBtn = $(self.modal["self"]).find("button[data-action=\""+ self.action.CHANGE_LATER +"\"]");
			ExtendBtn.on({
				"click" : function(){
					$(self.el[self.action.CHANGE_LATER]).trigger("submit");
				}
			});
			$('.password-info button[aria-expanded]').on('click', function() {
				var $button = $(this),
					$cont = $button.closest('.password-info').find('.password-info-cont');

				if ($cont.is(':visible')) {
					$button.attr('aria-expanded', false);
					$cont.stop().slideUp();
				} else {
					$button.attr('aria-expanded', true);
					$cont.stop().slideDown();
				}
			});
		},
		controler : function(_action){
			var opt = _action;
			var self = changePassword;
			$.ajax({
				url : opt.url,
				type : "post",
				data : opt.formData,
				dataType : "json",
				async : false,
				contentType : 'application/x-www-form-urlencoded; charset=UTF-8',
				xhrFields : {
					withCredentials : true
				},
				success : self.ajaxAPI[opt.action],
				error : self.viewAPI.error
			});
		},
		dispatch : function(_action){
			var self = changePassword;
			self.controler(_action);
		},
		ajaxAPI : {
			"change:later" : function(response){
				// change it later
				var self = changePassword;
				var isExtendSuccess = response.status === "success" ? true : false;
				if(!isExtendSuccess) return false;
				self.viewAPI["extend"](response);
			},
			"change:now" : function(response){
				// change now 
				var self = changePassword;
				var isChangeSuccess =  response.status === "success" ? true : false;
				if(!isChangeSuccess) {
					var failCase = response.code;
					if(!failCase) return self.viewAPI["error"]();
					var msg = response.message;
					return self.viewAPI["fail"](self.el[self.action.CHANGE_NOW], failCase, msg);
				}
				self.viewAPI["success"](response.message);
			},
		},
		interactionAPI : {
			"change:later": function(e){
				e.preventDefault(); // cut native event excute
				var self = changePassword;
				var target = self.el[self.action.CHANGE_LATER];
				var formData = $(target).serialize();
				self.dispatch({
					action : self.action.CHANGE_LATER,
					url : target.dataset.url,
					formData : xssfilter(formData)
				});
			},
			"change:now" : function(e){
				e.preventDefault(); // cut native event excute
				var self = changePassword;
				var isPassedValidate = $(self.el[self.action.CHANGE_NOW]).checkValidation();
				if(!isPassedValidate) return false;
				var target = e.currentTarget instanceof HTMLFormElement && e.currentTarget || self.el[self.action.CHANGE_NOW];
				var formData = $(target).serialize();
				self.dispatch({
					action : self.action.CHANGE_NOW,
					url : target.dataset.url,
					formData : xssfilter(formData)
				});
			}
		},
		viewAPI : {
			"success" : function(_msg, _relocation){
				var self = changePassword;
				$(self.modal["self"]).modal("hide");
				var indicator = $(self.modal["success"])[0];
				$(indicator).modal('show').find('.modal-footer button').on('click', function() {
					location.reload();
				});
			},
			"error" : function(){
				var self = changePassword;
				var indicator = $(self.modal["error"])[0];
				$(indicator).modal('show');
			},
			"fail" : function(_this, _errorcode, _msg){
				var $targetBlock = $(_this).find(".password-" + _errorcode);
				$targetBlock.find(".ajax-msg").text(_msg);
				$targetBlock.find(".ajax-msg").show().siblings().hide();
				$targetBlock.addClass("error");
			},
			"extend" : function(response){
				var self = changePassword;
				$(self.modal["self"]).modal("hide");
				var changePassSubmitData = JSON.parse($('input[name=submitData]').val());
				sign.login(changePassSubmitData);
			},
			"error" : function(_this, _errorcode, _msg){
				var $targetBlock = $(_this).find(".password-" + _errorcode);
				$targetBlock.find(".ajax-msg").text(_msg);
			}
		}
	}
	// object:simpleLayer
	const simpleLayer = {
		init: function() {
			// copy content
			$('.layer-simple').each(function() {
				const contentId = $(this).data('content');
				if(contentId) {	
					const html = $('#'+contentId).html();
					if(html){	// LGECS-411
						$(this).find('.layer-content').html(xssfilter(html, true));
					}
				}
			});
			// button event
			const $toggleBtn = $('.js-toggle-simplelayer');
			$toggleBtn.off().on('click', function(event) {
				event.preventDefault();
				const layerid = $(this).attr('aria-controls');
				const $layer = $('#' + layerid);
				// show the layer
				$('.layer-simple').removeClass('active');
				$layer.addClass('active');
				const layerHeight = parseInt($layer.outerHeight()) + 40;
				const windowHeight = $(window).height();
				if(layerHeight > windowHeight) {
					$layer.addClass('full');
				}
				$('body').addClass('modal-open');
				// set top-arrow's position
				const layerPosLeft = $(this).offset().left + ($(this).width()/2) - $layer.offset().left;
				$layer.find('.arrow-top').css({
					left: layerPosLeft
				});
				$layer.find('button.close').off().on('click', function() {
					$layer.removeClass('active');
					$layer.removeClass('full');
					$('body').removeClass('modal-open');
				});
			});
		}
	};
	// object:controlLabel
	const controlLabel = {
		el: null,
		inputs: null,
		init: function() {
			this.el = $('.signin-wrap.signin-emp');
			if(this.el.length == 0) return false;
			this.inputs = this.el.find('.common-sign-in-area .field-block').find('>input, select');
			this.runEvent();
			this.bindEvent();
		},
		changeClass: function(item) {
			if(item.val()) {	// LGECS-411
				item.addClass('inputted');
			} else {
				item.removeClass('inputted');
			}
		},
		runEvent: function() {
			this.inputs.each(function() {
				controlLabel.changeClass($(this));
			});
		},
		bindEvent: function() {
			this.inputs.on('keyup input', function() {
				controlLabel.changeClass($(this));
			});
		}
	};
	// show password, LGEBR-1275
	const passwordView =  function(){
        const el = $('.password-util');
        
		let input = el.prev('input');
		
        // EMP 20220127 START 박지영 - Sign in 디자인 변경
        if(
			el.closest('.signin-wrap').length > 0 && 
			el.closest('.signin-wrap').hasClass('signin-emp')
		) {
            input = el.parent().find('input');
        }
        // EMP 20220127 END 박지영 - Sign in 디자인 변경
        
        if(countryCode == 'BR' && sign.viewPasswordFlag != 'Y' && document.getElementById("signinForm")){
        	$('.password-util').addClass('d-none');
        }
        
        $('.btn-eyes').on('click', function(e){
        	var hide = $(this).parent().find('.txt-hide').text();
            var show = $(this).parent().find('.txt-show').text();
            var input = $(this).parent().parent().children('input');
            
    		e.preventDefault();
    		if($(this).hasClass('show')){
    			$(this).removeClass('show').attr('aria-label', hide);
    			input.attr('type', 'password');
    		}else{
    			$(this).addClass('show').attr('aria-label', show);
    			input.attr('type', 'text');
    		}
    		
    		$(this).focus();
    	});
    }
	const snsMoreBtn = {
		el: null,
		init: function() {
			this.el = $('.signin-wrap.signin-emp .sns-area-more button.more');
			this.bindEvent();
		},
		bindEvent: function() {
			this.el.on('click', function(event) {
				event.preventDefault();
				$('.sns-area').addClass('active');
			});
		}
	};
	const noticeMore = {
		el: null,
		btn: null,
		init: function() {
			this.el = $('.signin-wrap.signin-emp .notice-area.more-info');
			this.btn = this.el.find('button.more');
			if(this.el.length === 0) return false;
			const noticeWidth = parseInt(this.el.outerWidth());
			const textWidth = parseInt(this.el.find('.notice').outerWidth());
			const btnWidth = parseInt(this.btn.outerWidth());
			if(noticeWidth >= (textWidth + btnWidth + 10)) {
				this.el.addClass('active');
			} else {
				this.bindEvent();
			}
		},
		bindEvent: function() {
			const self = this;
			self.btn.on('click', function(event) {
				event.preventDefault();
				self.el.addClass('active');
			});
		}
	};
	// close the modal layer (팝업에서 모달 열었을때 버그 수정)
	const closeModalForce = function() {
		$('body').on('click', '.modal-backdrop, .modal-close', function() {
			$('.modal-backdrop').remove();
			$('.modal').hide();
			$('body').removeClass('modal-open');
		});
	}
	
	// reset password 추가분. as-is 따와서 적용
    if (document.getElementById('resendResetPasswordForm')) {
        // resend reset password;
        var resend = {
            el: document.getElementById('resendResetPasswordForm'),
            init: function () {
                resend.addEvent();
                resend.getCaptcha();
                
            },
            appendCaptcha: function(html){
                $('#captchaBox').empty();
                $('#captchaBox').append(html);
            },
            getCaptcha: function( showErrorCbFn ){
                if (typeof showErrorCbFn !== 'function'){
                    showErrorCbFn = new Function();
                }
                var $form = $(resend.el);
                var captchaUrl = $form.data('captchaUrl');
    
                if(!captchaUrl) return false;
    
                $.ajax({
                    type: "post",
                    url: captchaUrl,
                    async: false,
                    dataType: "json",
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        //$(sgin.el).attr("data-action-url", data.captchaUrl).data("actionUrl", data.captchaUrl);
                        
                        if (!!data.captchaHtml){
                            var $csrf;
                            if ( $form.find('[name=csrfToken]').length ){
                                $csrf = $form.find('[name=csrfToken]').eq(0);
                                $csrf.val( data.csrfToken );
                            } else {
                                $csrf = $('<input type="hidden" name="csrfToken">');
                                $csrf.val( data.csrfToken );
                                $form.append( $csrf );
                            }
                            
                            resend.appendCaptcha(data.captchaHtml);
                            showErrorCbFn();
                            
                        }
                    },
                    error: function(request,status,error) {
                        console.log("status: "+status);
                        console.log("error: "+error);
    
                        alert('SYSTEM ERROR');
                    }
                });
    
    
            },
            errorReset: function(){
                var $field = $(resend.el).find('.field-block');
                var errorMsg = $field.find('.error-msg span');

                $field.removeClass('error');
                errorMsg.hide();
            },
            showError: function(_t, _target, _msg){
                var block = $(_t).parents(".field-block");
                block.addClass('error').find(_target).text(_msg).show().siblings().hide();
                $(_t).focus();
            },
            addEvent: function(){
                $(resend.el).find('.btn-area [type="submit"]').on({
                    'click': function (e) {
                        e.preventDefault();
                        resend.errorReset();

                        var $form = $(resend.el);
                        if ($form.checkValidation() == false ) {
                            return false;
                        }

                        if ($form.data('submitted') === true) {
                            return;                            
                        } else {    
                        	/* LGEGMC-4766 start */
                        	if( $("#g-recaptcha").length > 0 && $('#g-sitekey').length > 0 && $("#useNewCaptchaView").length > 0 && $("#useNewCaptchaView").val() == "N"){
                				var reCaptcha_Key = $('#g-sitekey').val();
                	        	grecaptcha.enterprise.ready(function() {
                	        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
                	        			$("#g-recaptcha").val(btoa(token));
                	        			sendPassword();
                	        		});
                	        	});
                			}else{
                				sendPassword();
                			}
                			/* LGEGMC-4766 end */
                        	
                        	function sendPassword(){
	                        	var formSerializeArray = $form.serializeArray();
	                            var object = {};
	                            for (var i = 0; i < formSerializeArray.length; i++){
	                                object[formSerializeArray[i]['name']] = formSerializeArray[i]['value'];
	                            }
	                            object["emailAddr"] = xssfilter( $form.find('#txtBoxEmail').val() );
	                            
	
	                            // email ajax validation                             
	                            var ajaxUrl = $form.data('actionUrl');
	
	                            $('body').trigger('ajaxLoadBefore');
	                            $.ajax({
	                                type: 'post',
	                                url: ajaxUrl,
	                                async: false,
	                                dataType: 'json',
	                                data: object,
	                                xhrFields: {
	                                    withCredentials: true
	                                },
	                                success: function(res) {
	
	                                    if (res.result) {                                    
	                                        resend.errorReset();
	                                        $form.data('submitted', true);
	                                        // 20200319 START 김우람 || BR email list modal
	                                        if ( res.cpfListFlag == "Y" ){
	                                            
	                                            if ( res.resultList.length == 1){
	                                                // 20200326 START 김우람 || BR email list form 키값추가
	                                                if ( !$form.find('[name=emailCode]').length ){
	                                                    $form.append('<input type="hidden" name="emailCode" />');
	                                                }
	
	                                                if ( !$form.find('[name=cpfListFlag]').length ){
	                                                    $form.append('<input type="hidden" name="cpfListFlag" />');
	                                                }
	
	                                                if ( !$form.find('[name=sKey]').length ){
	                                                    $form.append('<input type="hidden" name="sKey" />');
	                                                }
	
	                                                $form.find('[name=emailCode]').val( res.resultList[0].emailCode );
	                                                $form.find('[name=cpfListFlag]').val( res.cpfListFlag );
	                                                $form.find('[name=sKey]').val( res.sKey );
	                                                // 20200326 END 김우람 || BR email list form 키값추가
	                                                $form.submit();
	                                            } else {
	                                                var emailContainer = $('#modal_email_select').find('.period ul');
	                                                emailContainer.empty();
	
	                                                $.each(res.resultList , function( idx ){
	                                                    var emailCode = this.emailCode;
	                                                    var email = this.email;
	                                                    var radioHtml = '<li><label class="radio-box" for="option_'+ idx +'">';
	                                                    radioHtml += '<input type="radio" name="emailradio" id="option_'+ idx +'" value="'+ emailCode +'" />';
	                                                    radioHtml += '<span class="radio-btn"></span><span class="text">'+ email +'</span>';
	                                                    radioHtml += '</label></li>';                                                
	                                                    emailContainer.append( $(radioHtml) );
	                                                });
	
	                                                var emailOkBtn = $('#modal_email_select').find('.email-list button');
	                                                
	                                                emailOkBtn.off().on('click', function(e){
	                                                    e.preventDefault();
	                                                    var checkedRadio = emailContainer.find('input:radio:checked');
	                                                    // 20200325 START 김우람 || BR 이메일 리스트 버그 수정
	                                                    if (!checkedRadio.length){
	                                                        return;
	                                                    }
	                                                    // 20200325 END 김우람 || BR 이메일 리스트 버그 수정
	
	                                                    // 20200326 START 김우람 || BR email list form 키값추가
	                                                    if ( !$form.find('[name=emailCode]').length ){
	                                                        $form.append('<input type="hidden" name="emailCode" />');
	                                                    }
	    
	                                                    if ( !$form.find('[name=cpfListFlag]').length ){
	                                                        $form.append('<input type="hidden" name="cpfListFlag" />');
	                                                    }
	    
	                                                    if ( !$form.find('[name=sKey]').length ){
	                                                        $form.append('<input type="hidden" name="sKey" />');
	                                                    }
	    
	                                                    $form.find('[name=emailCode]').val( checkedRadio.val() );
	                                                    $form.find('[name=cpfListFlag]').val( res.cpfListFlag );
	                                                    $form.find('[name=sKey]').val( res.sKey );
	                                                    // 20200326 END 김우람 || BR email list form 키값추가
	
	                                                    $form.submit();
	                                                });
	
	                                                $('#modal_email_select').off().on('hide.bs.modal', function(){
	                                                    $form.data('submitted', false);
	                                                });
	
	                                                $('#modal_email_select').modal();
	                                            }
	                                            
	                                        } else {
	                                            $form.submit();
	                                        }
	                                        // 20200319 END 김우람 || BR email list modal
	                                        
	                                    } else {      
	                                    	// LGECI-541 start
	            							if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
	            								if( !!$('#g-recaptcha').val() && $("#useNewCaptchaView").val() == "Y"){
	            									reload_recaptcha_wrapper();
	            								}
	            							}
	            							// LGECI-541 end
	                                    	
	                                    	// LGEPA-473 start : test
	                                    	if (res.error.code == "1009") {
	                                    		var _htm = "<form action='' id='signinForm' method='post'>"
	                                    			_htm += "<fieldset>";
	                                    		    _htm += "<input type='hidden' id='txtBoxEmail' name='emailAddr' value='"+res.error.mail+"'>";
	                                    		    _htm += "<input type='hidden' id='txtBoxPassword' name='password' value='abc1234!@'>";
	                                    		    _htm += "<input type='hidden' name='submitData' value='"+ JSON.stringify( res )+"'>";
		                                    		_htm += "<input type='hidden' name='serverEnv' value='"+$("#resendResetPasswordForm").find("input[name='serverEnv']").val()+"'>";
		                                    		_htm += "</fieldset>";
		                                    		_htm += "</form>";
		                                    		
	                                    		$('body').append(_htm);
	                    						var form = $("#signinForm");
	                    						form.attr("action",$("#resendResetPasswordForm").attr("action").replace("/forgotPassword","/login"));
	                    						form.submit();
	                                    		
	                                    		return;
	                                    	}
	                                    	// LGEPA-473 end
	                                    	
	                                        if (!!res.error.captchaCodeTextBox){
	                                            // validation fail
	
	                                            resend.getCaptcha(function(){
	                                                for (var key in res.error) {
	                                                    var $field = $(resend.el).find('input[name="' + key + '"]');
	                                                    
	                                                    if ($field.length) {
	                                                        resend.showError($field, '.ajax-msg', res.error[key]);
	                                                    }
	                                                }
	                                            });
	                                        } else {
	                                        	if('Y' == res.error.customerInfoEmpAccountFlag){
	                                                $('#modal_emp_only_reset_password').find('a').attr('href',res.error.customerInfoEmpResetUrl);
													$('#modal_emp_only_reset_password').modal('show');
												}else{
													var $field = $(resend.el).find('.field-block');
		                                            var errorMsg = $field.find('.error-msg .registered');
		
		                                            $field.addClass('error');
		                                            errorMsg.show();	
												}
	                                        }
	                                        //LGCOMMON-6086 Start
	                                        if (res.error.code == "7003") {
	                                        	$form.submit();
	                                        }
	                                        //LGCOMMON-6086 End
	                                    }
	                                },
	                                error: function(request,status,error) {
	                                    console.log("status: "+status);
	                                    console.log("error: "+error);
	                                },
	                                complete: function(){
	                                    $('body').trigger('ajaxLoadEnd');
	                                }
	                            });
	                        }
                        }
                    }
                });
            }
        };
        resend.init();
    }

    if (document.getElementById('resetpasswordForm')) {
        // reset password;
        var pw = {
            el: document.getElementById('resetpasswordForm'),
            $error: null,
            init: function () {
                pw.$error = $(pw.el).find('.whole-error-msg');
                pw.addEvent();
                
                // Reset password | More details_Slide Toggle | 2019-12-02 yhjang
                // EMP 20220128 START 이상현 - event selector 수정
                // $('.password-info .btn-more').on('click', function() {
                $('.password-info button[aria-expanded]').on('click', function() {
                // EMP 20220128 END 이상현 
                    var $button = $(this),
                        $cont = $button.closest('.password-info').find('.password-info-cont');

                    if ($cont.is(':visible')) {
                        $button.attr('aria-expanded', false);
                        $cont.stop().slideUp();
                    } else {
                        $button.attr('aria-expanded', true);
                        $cont.stop().slideDown();
                    }
                });
            },
            beforeSubmit: function (e) {
                e.preventDefault();

                var _this = e.currentTarget;
                var _fields = {
                    new: $(_this).find('#txtBoxPassword').get(0),
                    newConfirm: $(_this).find('#txtBoxPasswordConfirm').get(0)
                };

                if ($(_this).checkValidation()) {
                	// PJTGPEMP-25
//                    var test = true;
//                    if(test){
//                        console.log("test code for novalidate submit");
//                        _this.submit();
//                        return false;
//                    }
                    var url = _this.getAttribute('data-url');
					var param = xssfilter($(_this).serialize());
					var methodType = $(_this).data('ajaxMethod') || "post";
					if(_fields.new.value == _fields.newConfirm.value) {
                        $('body').trigger('ajaxLoadBefore');
                        $(pw.el).find('.whole-error-msg').hide().find('.match').hide();
						ajax.call(url, param, 'json', function(data){
							$('body').trigger('ajaxLoadEnd');
							
							if(!data.result) {
								if(!data.error) {
									// change fail
									$('#modal_change_my_password_fail').modal('show');

								} else {
                                    // invalid pw (fail)
                                    for(var key in data.error) {
                                        var $field = $(_this).find('input[name="'+key+'"]');
                                        pw.showError($field, '.ajax-msg', data.error[key]);
									}
								}

								// PJTGPEMP-25   failure
								if ( data.message == "expired" ) {

									var errorMsg = document.getElementById("serverErrorMsg");
									if (!errorMsg) {
											var html =	'<div class="modal modal-simple fade" id="serverErrorMsg" tabindex="-1" role="dialog" data-backdrop="false">';
											html += '	<div class="modal-dialog" role="document">';
											html += '		<div class="modal-content">';
											html += '			<div class="modal-body">';
											html += '				<div class="simple-content-box">';
											html += '					<p class="content-paragraph">Reset Password Link Expired</p>';
											html += '				</div>';
											html += '			</div>';
											html += '			<div class="modal-footer">';
											html += '				<button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>';
											html += '			</div>';	
											html += '		</div>';
											html += '	</div>';
											html += '</div>';
										$('body').append(html);
										errorMsg = document.getElementById("serverErrorMsg");
										$(errorMsg).find('.content-paragraph').text($('.expired').text());
										$(errorMsg).modal("show");
									} else if (!$(errorMsg).hasClass('show')) {
										$(errorMsg).modal("show");
									}
									
									$(errorMsg).find('button[data-dismiss=modal]').on('click.close', function() {
										setTimeout(function() { location.href = data.returnUrl; }, 100);
									});

								} else {
									$(pw.el).find('.left-column').find('.field-block').addClass('error').find('.error-msg').show().find('.ajax-msg2').text(data.message).show().siblings().hide();
									$(pw.el).find('.whole-error-msg').hide();
								}
								
							}else {
								// change successed
								adobeTrackEvent('mylg-profile-update', {profile_update : 'password', page_event : {update_profile : true}});
								var url = _this.action;
								
								$('#modal_change_my_password_success').modal('show').find('.modal-footer button').on('click', function() {
									location.href = url;
								});
								// PJTGPEMP-25
								if ( data.message == "success" ) {
									setTimeout(function() {
										location.href = _this.action;
									}, 100);
								}

							}
						},methodType);
					}else {
                        $(pw.el).find('.whole-error-msg').show().find('.match').show().siblings().hide();
					}
                }
            },
            showError: function(_t, _target, _msg){
				var block = $(_t).parents(".field-block");
				block.addClass('error').find(_target).text(_msg).show().siblings().hide();
			},
            // check: function (val) {
            //     var result = false;
            //     if (val.length > 7) {
            //         var n = /^.*(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
            //         result = n.test(val);
            //     }
            //     return result;
            // },
            addEvent: function () {
                $(pw.el).on({
                    submit: pw.beforeSubmit
                });
                // $(pw.el).on({
                //     keydown: function (e) {
                //         if (e.keyCode == 13 && e.currentTarget.value != '') {
                //             console.log(pw.check($('#txtBoxPassword').val()));
                //             if (!pw.check($('#txtBoxPassword').val())) {
                //                 e.preventDefault();
                //                 $('#txtBoxPassword').parents('.field-block').addClass('error')
                //                     .find('.error-msg .invalid').show().siblings().hide();
                //             }
                //         }
                //     },
                //     /* Start of LGEUS-11769 */
                //     keyup: function (e) {
                //         if (e.currentTarget.value == '' || pw.check($('#txtBoxPassword').val())) {
                //             // remove password requirement
                //             e.preventDefault();
                //             $('#txtBoxPassword').parents('.field-block').removeClass('error');
                //         }
                //     }
                //     /* End of LGEUS-11769 */
                // }, '#txtBoxPassword, #txtBoxPasswordConfirm');
            }
        };
        pw.init();
    }
    
	// initialize
	// fgpw.init();
	sign.init();
	signinEmp.init();
	simpleLayer.init();
	controlLabel.init();
	snsMoreBtn.init();
	noticeMore.init();
    passwordView();
	closeModalForce();
});

// LGECS-411 START : sign-in, signin-checkout 페이지 상에서 입력값이 존재함에도 placeholder가 노출되는 문제점 수정
//					 load 시점에서 다시 한 번 입력값 존재 여부 확인하도록 수정
$(window).on("load", function () {
	const controlLabel = {
		el: null,
		inputs: null,
		init: function() {
			this.el = $('.signin-wrap.signin-emp');
			if(this.el.length == 0) return false;
			this.inputs = this.el.find('.common-sign-in-area .field-block').find('>input, select');
			this.runEvent();
		},
		changeClass: function(item) {
			if(item.val()) {
				item.addClass('inputted');
			} else {
				item.removeClass('inputted');
			}
		},
		runEvent: function() {
			this.inputs.each(function() {
				controlLabel.changeClass($(this));
			});
		}
	};

	controlLabel.init();
});

// LGECS-411 END